// Brand-image JSON-LD helpers. Wraps geoImageObject with Colorado Web
// Impressions' Woodmen Rd office coordinates baked in so every Chris/logo
// image carries consistent geo attribution.

import { geoImageObject } from "./geoImageSchema";

const SITE = "https://coloradowebimpressions.com";
const OFFICE_GEO = { lat: 38.9359976, lng: -104.7653118 };
const CITY = "Colorado Springs";

export const OFFICE_COORDS = OFFICE_GEO;
export const OFFICE_CITY = CITY;

function absUrl(src: string): string {
  if (/^https?:\/\//i.test(src)) return src;
  return `${SITE}${src.startsWith("/") ? src : `/${src}`}`;
}

export function chrisImageObject(src: string, caption: string, width = 800, height = 800) {
  return geoImageObject({
    url: absUrl(src),
    caption,
    description: caption,
    cityName: CITY,
    geo: OFFICE_GEO,
    width,
    height,
  });
}

export function logoImageObject(src: string, caption = "Colorado Web Impressions logo — Colorado Springs web design agency", width = 512, height = 512) {
  return geoImageObject({
    url: absUrl(src),
    caption,
    description: caption,
    cityName: CITY,
    geo: OFFICE_GEO,
    width,
    height,
  });
}
